<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div class="mt-2" v-if="withTime">
      {{getValueWithTime(property)}}
    </div>
    <div v-else>
      {{getValue(property)}}
    </div>
  </div>

</template>

<script>

export default {

  name: 'ShowDateField',

  props: {
    object: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    property: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    withTime: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    getValue () {
      return property => this.object? ((this.object[property] || this.object[property] === false) ? new Date(this.object[property]).toLocaleDateString('fr-FR') : '-'): '-'
    },

    getValueWithTime () {
      return property => this.object? ((this.object[property] || this.object[property] === false) ? new Date(this.object[property]).toLocaleDateString('fr-FR') + ' ' + new Date(this.object[property]).toLocaleTimeString('fr-FR') : '-'): '-'
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowDateField.vue